import { Disclosure } from '@kerfjs/ui/disclosure';
import { List } from '@kerfjs/ui/list';
import { Text } from '@kerfjs/ui/text';
import type { SafeHtml } from 'kerfjs';

import type { AnalysisReport } from '../../../../../data/api.js';
import { me } from '../../../../../data/state.js';
import { supplierLeads } from '../../../../../lib/supplier-leads.js';
import { SupplierLeadList } from '../../../../supplier-lead-list.js';
import type { SummaryLine } from '../../summary-context.js';

export function SupplierLeadsSection({ report, lines }: { report: AnalysisReport; lines: SummaryLine[] }): SafeHtml {
  const leads = supplierLeads(report.benchmarks, report.verdicts);
  if (leads.length === 0) return <></>;
  const canAdd = me.value?.roles.some((role) => role === 'reviewer' || role === 'admin') === true;
  return (
    <section data-demand-supplier-leads>
      <Disclosure title="Where to source" detail={`${String(leads.length)} cited lead${leads.length === 1 ? '' : 's'}`}>
        <List gap="m">
          {lines.map((line) => {
            const choices = leads.filter((lead) => lead.lineItemId === line.id);
            if (choices.length === 0) return null;
            return (
              <section data-supplier-line={line.id}>
                <List gap="xs">
                  <Text variant="h3">{`Line ${String(line.lineNumber)}: ${line.description}`}</Text>
                  <SupplierLeadList leads={choices} canAdd={canAdd} />
                </List>
              </section>
            );
          })}
        </List>
      </Disclosure>
    </section>
  );
}
